var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("title-component"),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("card-title-component", {
              attrs: { title: _vm.$t("contacts.resultSection.title") }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "card-content" })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row filter-row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "b-form-group",
              { staticClass: "mb-0" },
              [
                _c(
                  "b-input-group",
                  [
                    _c("b-form-input", {
                      staticClass: "o-form",
                      attrs: {
                        placeholder: _vm.$t(
                          "contacts.searchSection.searchInputPlaceholder"
                        )
                      },
                      model: {
                        value: _vm.filter,
                        callback: function($$v) {
                          _vm.filter = $$v
                        },
                        expression: "filter"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-input-group-append",
                      [
                        _c(
                          "b-btn",
                          {
                            staticClass: "o-button clear-button",
                            attrs: { disabled: !_vm.filter },
                            on: {
                              click: function($event) {
                                _vm.filter = ""
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t("contacts.searchSection.clearButton")
                                ) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "add-contact-link" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "b-modal",
                    rawName: "v-b-modal.add-contact-modal",
                    modifiers: { "add-contact-modal": true }
                  }
                ],
                attrs: { href: "javascript:void(0)" }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("contacts.addContactButton")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c(
              "b-table",
              {
                attrs: {
                  id: "contacts-table",
                  stacked: "lg",
                  hover: "",
                  small: "",
                  fixed: "",
                  items: _vm.localContacts,
                  "per-page": _vm.perPage,
                  "current-page": _vm.currentPage,
                  "total-rows": _vm.totalRows,
                  fields: _vm.computedFields,
                  filter: _vm.filter
                },
                on: { filtered: _vm.onFiltered },
                scopedSlots: _vm._u([
                  {
                    key: "actions",
                    fn: function(row) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.deleteContact(row.item.id)
                              }
                            }
                          },
                          [_c("icon", { attrs: { name: "trash-o" } })],
                          1
                        ),
                        _vm._v("\n                    |\n                    "),
                        !row.item.onGuestlist
                          ? _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.putOnGuestlist(row.item)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "contacts.resultSection.table.putOnAction"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        row.item.onGuestlist
                          ? _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.removeFromGuestlist(row.item)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "contacts.resultSection.table.removeFromAction"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              },
              [
                _c("template", {
                  staticClass: "o-thead",
                  slot: "HEAD_firstname"
                })
              ],
              2
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("b-pagination", {
              attrs: {
                align: "center",
                size: "sm",
                "total-rows": _vm.totalRows,
                "per-page": _vm.perPage
              },
              model: {
                value: _vm.currentPage,
                callback: function($$v) {
                  _vm.currentPage = $$v
                },
                expression: "currentPage"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col button-div" },
          [
            _c(
              "b-button",
              {
                staticClass: "delete-all-button o-button",
                attrs: { disabled: _vm.contacts.length < 1 },
                on: { click: _vm.deleteAllContactsDialog }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("contacts.deleteAllButton")) +
                    "\n            "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "add-contact-link" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "b-modal",
                    rawName: "v-b-modal.add-contact-modal",
                    modifiers: { "add-contact-modal": true }
                  }
                ],
                attrs: { href: "javascript:void(0)" }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("contacts.addContactButton")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-sm-6" },
          [
            _c("card-title-component", {
              attrs: { title: _vm.$t("contacts.qrSection.title") }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "card-content" }, [
              _c("div", { staticClass: "app-instructions" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("contacts.qrSection.description")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("qrcode", {
                    attrs: { value: _vm.idToken, options: { size: 400 } }
                  })
                ],
                1
              )
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "add-contact-modal",
          attrs: {
            id: "add-contact-modal",
            "ok-title": "Speichern",
            "cancel-title": "Abbrechen",
            "hide-header": true,
            "hide-footer": true
          }
        },
        [_c("add-contact-component")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "store-badges" }, [
      _c(
        "a",
        {
          attrs: {
            href:
              "https://itunes.apple.com/us/app/omyfu/id1423062463?ls=1&mt=8",
            target: "_blank"
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("../assets/images/icons/app_store_badge.png"),
              height: "40px"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://play.google.com/store/apps/details?id=com.omyfu.androidApp&hl=de",
            target: "_blank"
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("../assets/images/icons/google_play_badge_bw.png"),
              height: "40px"
            }
          })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7680d62c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7680d62c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactsComponent.vue
// module id = null
// module chunks = 